module.exports = __webpack_public_path__ + "img/exitCssFull.d42a83d7.svg";